import { render, staticRenderFns } from "./SimplePie.vue?vue&type=template&id=054d5696&"
import script from "./SimplePie.vue?vue&type=script&lang=js&"
export * from "./SimplePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports